import { render, staticRenderFns } from "./UnitProductDataTable.vue?vue&type=template&id=178ef465&"
import script from "./UnitProductDataTable.vue?vue&type=script&lang=js&"
export * from "./UnitProductDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UnitProductDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VForm,VIcon,VPagination,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178ef465')) {
      api.createRecord('178ef465', component.options)
    } else {
      api.reload('178ef465', component.options)
    }
    module.hot.accept("./UnitProductDataTable.vue?vue&type=template&id=178ef465&", function () {
      api.rerender('178ef465', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Product/components/Unit/UnitProductDataTable.vue"
export default component.exports